<div *ngIf="loadingConfig">
    <span class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle
                class="path"
                cx="50"
                cy="50"
                fill="none"
                r="20"
                stroke-miterlimit="10"
                stroke-width="2"
            />
        </svg>
    </span>
</div>
<h3>Configuration</h3>
<form
    #configForm="ngForm"
    (ngSubmit)="onSubmit()"
    *ngIf="!loadingConfig"
    class="page-form"
>
    <div>
        <div class="lined-input-group">
            <label for="maximumAllowedCredits"> Max Allowed Credits </label>
            <input
                #maximumAllowedCredits="ngModel"
                [(ngModel)]="config.maximumAllowedCredits"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="maximumAllowedCredits"
                name="maximumAllowedCredits"
                required
                type="number"
            />
            <div
                *ngIf="
                    maximumAllowedCredits.invalid &&
                    (maximumAllowedCredits.dirty ||
                        maximumAllowedCredits.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="maximumAllowedCredits.errors.required">
                    Max Allowed Credits is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="maxExpensesSubmitable">
                Max Expenses Claim Amount
            </label>
            <input
                #maxExpensesSubmitable="ngModel"
                [(ngModel)]="config.maxExpensesSubmitable"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="maxExpensesSubmitable"
                name="maxExpensesSubmitable"
                required
                type="number"
            />
            <div
                *ngIf="
                    maxExpensesSubmitable.invalid &&
                    (maxExpensesSubmitable.dirty ||
                        maxExpensesSubmitable.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="maxExpensesSubmitable.errors.required">
                    Max Expenses Claim Amount is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="subsistencePerDay"> Subsistence Amount Per Day </label>
            <input
                #subsistencePerDay="ngModel"
                [(ngModel)]="config.subsistencePerDay"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="subsistencePerDay"
                name="subsistencePerDay"
                required
                type="number"
            />
            <div
                *ngIf="
                    subsistencePerDay.invalid &&
                    (subsistencePerDay.dirty || subsistencePerDay.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="subsistencePerDay.errors.required">
                    Subsistence Amount Per Day is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="maxAccommodationPricePerNight">
                Max Accommodation Price Per Night
            </label>
            <input
                #maxAccommodationPricePerNight="ngModel"
                [(ngModel)]="config.maxAccommodationPricePerNight"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="maxAccommodationPricePerNight"
                name="maxAccommodationPricePerNight"
                required
                type="number"
            />
            <div
                *ngIf="
                    maxAccommodationPricePerNight.invalid &&
                    (maxAccommodationPricePerNight.dirty ||
                        maxAccommodationPricePerNight.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="maxAccommodationPricePerNight.errors.required">
                    Max Accommodation Price Per Night is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="carAllowancePerKm"> Car Allowance Per Kilometer </label>
            <input
                #carAllowancePerKm="ngModel"
                [(ngModel)]="config.carAllowancePerKm"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="carAllowancePerKm"
                name="carAllowancePerKm"
                required
                type="number"
            />
            <div
                *ngIf="
                    carAllowancePerKm.invalid &&
                    (carAllowancePerKm.dirty || carAllowancePerKm.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="carAllowancePerKm.errors.required">
                    Car Allowance Per Kilometer is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="subsistencePerDay">
                Substitute Cost Per Partial Day
            </label>
            <input
                #substituteCostPerPartialDay="ngModel"
                [(ngModel)]="config.substituteCostPerPartialDay"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="substituteCostPerPartialDay"
                name="substituteCostPerPartialDay"
                required
                type="number"
            />
            <div
                *ngIf="
                    substituteCostPerPartialDay.invalid &&
                    (substituteCostPerPartialDay.dirty ||
                        substituteCostPerPartialDay.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="substituteCostPerPartialDay.errors.required">
                    Substitute Cost Per Partial Day is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="substituteCostPerFullDay">
                Substitute Cost Per Full Day
            </label>
            <input
                #substituteCostPerFullDay="ngModel"
                [(ngModel)]="config.substituteCostPerFullDay"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="substituteCostPerFullDay"
                name="substituteCostPerFullDay"
                required
                type="number"
            />
            <div
                *ngIf="
                    substituteCostPerFullDay.invalid &&
                    (substituteCostPerFullDay.dirty ||
                        substituteCostPerFullDay.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="substituteCostPerFullDay.errors.required">
                    Substitute Cost Per Full Day is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="subsistencePerDay">
                Substitute Maximum Cost Per Grid Day
            </label>
            <input
                #substituteMaximumGridCostPerDay="ngModel"
                [(ngModel)]="config.substituteMaximumGridCostPerDay"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="substituteMaximumGridCostPerDay"
                name="substituteMaximumGridCostPerDay"
                required
                type="number"
            />
            <div
                *ngIf="
                    substituteMaximumGridCostPerDay.invalid &&
                    (substituteMaximumGridCostPerDay.dirty ||
                        substituteMaximumGridCostPerDay.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="substituteMaximumGridCostPerDay.errors.required">
                    Substitute Maximum Cost Per Grid Day is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="dateHelpText"> Date Help Text </label>
            <textarea
                #dateHelpText="ngModel"
                [(ngModel)]="config.dateHelpText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="dateHelpText"
                name="dateHelpText"
                required
                rows="2"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    dateHelpText.invalid &&
                    (dateHelpText.dirty || dateHelpText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="dateHelpText.errors.required">
                    Date Help Text is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="conferenceInfoText">
                Attach Conference Information Text
            </label>
            <textarea
                #conferenceInfoText="ngModel"
                [(ngModel)]="config.conferenceInfoText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="conferenceInfoText"
                name="conferenceInfoText"
                required
                rows="1"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    conferenceInfoText.invalid &&
                    (conferenceInfoText.dirty || conferenceInfoText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="conferenceInfoText.errors.required">
                    Attach Conference Information Text is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label for="pdExplanationHelpText">
                PD Explanation Help Text
            </label>
            <textarea
                #pdExplanationHelpText="ngModel"
                [(ngModel)]="config.pdExplanationHelpText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="pdExplanationHelpText"
                name="pdExplanationHelpText"
                required
                rows="1"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    pdExplanationHelpText.invalid &&
                    (pdExplanationHelpText.dirty ||
                        pdExplanationHelpText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="dateHelpText.errors.required">
                    PD Explanation Help Text is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="substituteExpenseHelpText">
                Substitute Expenses Help Text
            </label>
            <textarea
                #substituteExpenseHelpText="ngModel"
                [(ngModel)]="config.substituteExpenseHelpText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="substituteExpenseHelpText"
                name="substituteExpenseHelpText"
                required
                rows="7"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    substituteExpenseHelpText.invalid &&
                    (substituteExpenseHelpText.dirty ||
                        substituteExpenseHelpText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="substituteExpenseHelpText.errors.required">
                    Substitute Expenses Help Text is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="mileageHelpText"> Mileage Help Text </label>
            <textarea
                #mileageHelpText="ngModel"
                [(ngModel)]="config.mileageHelpText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="mileageHelpText"
                name="mileageHelpText"
                required
                rows="1"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    mileageHelpText.invalid &&
                    (mileageHelpText.dirty || mileageHelpText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="mileageHelpText.errors.required">
                    Mileage Help Text is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="subsistenceHelpText"> Subsistence Help Text </label>
            <textarea
                #subsistenceHelpText="ngModel"
                [(ngModel)]="config.subsistenceHelpText"
                [readOnly]="disableForNonAdmin"
                class="form-control text"
                id="subsistenceHelpText"
                name="subsistenceHelpText"
                required
                rows="2"
                type="text"
            ></textarea>
            <div
                *ngIf="
                    subsistenceHelpText.invalid &&
                    (subsistenceHelpText.dirty || subsistenceHelpText.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="subsistenceHelpText.errors.required">
                    Subsistence Help Text is required.
                </div>
            </div>
        </div>

        <div class="submit-button-div">
            <div *ngIf="savingConfig">
                <span class="app-loading">
                    <svg class="spinner" viewBox="25 25 50 50">
                        <circle
                            class="path"
                            cx="50"
                            cy="50"
                            fill="none"
                            r="20"
                            stroke-miterlimit="10"
                            stroke-width="2"
                        />
                    </svg>
                </span>
            </div>
            <button
                [disabled]="
                    !configForm.form.valid || savingConfig || disableForNonAdmin
                "
                class="btn btn-primary"
                type="submit"
            >
                Save
            </button>
        </div>
    </div>

    <div *ngIf="!disableForNonAdmin">
        <h3>Bulk Credit Load</h3>
        <div class="past-bulk-credit-list">
            <h6>Past Credit Loads:</h6>
            <table class="list-table smaller past-credit-loads-table">
                <thead>
                <tr>
                    <th class="header">Date</th>
                    <th class="header">Loaded By</th>
                    <th class="header">Amount</th>
                    <th class="header">To Max</th>
                    <th class="header">Active Members</th>
                    <th class="header">Members Completed</th>
                    <th class="header">Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="loadingPastCredits">
                    <td colspan="5">
                            <span class="app-loading">
                                <svg class="spinner" viewBox="25 25 50 50">
                                    <circle
                                        class="path"
                                        cx="50"
                                        cy="50"
                                        fill="none"
                                        r="20"
                                        stroke-miterlimit="10"
                                        stroke-width="2"
                                    />
                                </svg>
                            </span>
                    </td>
                </tr>
                <tr
                    *ngFor="let pastCreditLoad of pastCreditLoads"
                    class="list-row"
                >
                    <td title="{{ pastCreditLoad.startDate }}">
                        {{ getAgo(pastCreditLoad.startDate) }}
                    </td>
                    <td>
                            <span
                                title="{{ pastCreditLoad.startedByUserEmail }}"
                            >
                                {{ pastCreditLoad.startedByUserName }}
                            </span>
                    </td>
                    <td>
                        {{
                            pastCreditLoad.amountToLoad
                                | currency
                                : "CAD"
                                    : "symbol-narrow"
                                    : "1.2-2"
                        }}
                    </td>
                    <td>
                        {{
                            pastCreditLoad.toMaximumOf
                                | currency
                                : "CAD"
                                    : "symbol-narrow"
                                    : "1.2-2"
                        }}
                    </td>
                    <td>
                        {{ pastCreditLoad.membersToLoad }}
                    </td>
                    <td>
                        {{ pastCreditLoad.membersLoaded }}
                    </td>
                    <td>
                        {{ pastCreditLoad.loadStatus }}
                    </td>
                </tr>
                </tbody>
            </table>
            <div
                *ngIf="
                    !loadingPastCredits &&
                    (!pastCreditLoads || !pastCreditLoads.length)
                "
            >
                No previous bulk credit loads found.
            </div>
        </div>
        <div
            *ngIf="!loadingRosterMembers && !loadingConfig"
            class="new-bulk-credits"
        >
            <div class="bulk-load-info">
                There are {{ rosterMembers.length }} active members. The maximum
                credit balance is
                {{
                    config.maximumAllowedCredits
                        | currency : "CAD" : "symbol-narrow" : "1.2-2"
                }}.
            </div>
            <div *ngIf="!activeCreditLoad" class="add-credits-div">
                Bulk load credits: $
                <input
                    [(ngModel)]="bulkCreditsToAdd"
                    [min]="0.01"
                    [step]="0.01"
                    id="bulkCreditsToAdd"
                    name="bulkCreditsToAdd"
                    type="number"
                />
                <button
                    (click)="startBulkCredit(bulkCreditsToAdd)"
                    [disabled]="
                        !bulkCreditsToAdd ||
                        loadingRosterMembers ||
                        loadingConfig ||
                        disableForNonAdmin
                    "
                    class="btn btn-secondary"
                    type="button"
                >
                    Start Bulk Credit Add
                </button>
            </div>
            <div
                *ngIf="activeCreditLoad"
                [ngSwitch]="activeCreditLoad.loadStatus"
                class="active-credit-load-detail"
            >
                <div *ngSwitchCase="'Finished'">
                    Bulk credit load
                    <span class="succeeded-span">succeeded</span>;
                    {{ activeCreditLoad.MembersLoaded }} members credited. View
                    detailed results below.
                </div>
                <div *ngSwitchCase="'Failed'">
                    The bulk load operation
                    <span class="failed-span">failed</span>.
                    {{ activeCreditLoad.MembersLoaded }} out of
                    {{ rosterMembers.length }} members were credited.
                </div>
                <div *ngSwitchCase="'Finishing'">
                    <span class="inline-spinner"></span>Finishing up...
                </div>
                <div *ngSwitchCase="'Started'">
                    <span class="inline-spinner"></span>Bulk load in progress:
                    {{ processingRosterIndex + 1 }}/{{ rosterMembers.length }}.
                    <span class="do-not-click-warning">
                        Please do not close this window or click anything inside
                        it!
                    </span>
                </div>
                <div *ngSwitchDefault>
                    <span class="inline-spinner"></span>Starting bulk credit
                    load...
                </div>
            </div>
            <div>
                <span *ngIf="activeCreditLoad">
                    Results of this bulk credit load:
                </span>
                <span *ngIf="!activeCreditLoad">
                    Active members to credit:
                </span>
                <table class="list-table smaller new-credit-roster-table">
                    <thead>
                    <tr class="list-row">
                        <th class="header">Member</th>
                        <th class="header">Last Seen</th>
                        <th class="header">Last Credited</th>
                        <th class="header">Last Credited Amount</th>
                        <th class="header left-border">
                                <span [ngClass]="{ hidden: !activeCreditLoad }">
                                    Previous Balance
                                </span>
                        </th>
                        <th class="header">
                                <span [ngClass]="{ hidden: !activeCreditLoad }">
                                    Credits Added
                                </span>
                        </th>
                        <th class="header right-border">
                                <span [ngClass]="{ hidden: !activeCreditLoad }">
                                    Resulting Balance
                                </span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        *ngFor="let member of rosterMembers"
                        class="list-row"
                    >
                        <td>
                                <span title="{{ member.email }}">
                                    {{ member.firstName }} {{ member.lastName }}
                                </span>
                        </td>
                        <td title="{{ member.lastSeen }}">
                            {{ getAgo(member.lastSeen) }}
                        </td>
                        <td title="{{ member.lastCreditLoadDate }}">
                            {{ getAgo(member.lastCreditLoadDate) }}
                        </td>
                        <td>
                            {{
                                member.lastCreditLoadAmount
                                    | currency
                                    : "CAD"
                                        : "symbol-narrow"
                                        : "1.2-2"
                            }}
                        </td>
                        <td class="left-border">
                                <span *ngIf="activeCreditLoad">
                                    {{
                                        member.previousBalance
                                            | currency
                                            : "CAD"
                                                : "symbol-narrow"
                                                : "1.2-2"
                                    }}
                                </span>
                        </td>
                        <td>
                                <span
                                    *ngIf="activeCreditLoad"
                                    class="credits-added"
                                >
                                    <span
                                        *ngIf="member.isBeingCredited"
                                        class="inline-spinner"
                                    ></span>
                                    {{
                                        member.creditsAdded
                                            | currency
                                            : "CAD"
                                                : "symbol-narrow"
                                                : "1.2-2"
                                    }}
                                </span>
                        </td>
                        <td class="right-border">
                                <span *ngIf="activeCreditLoad">
                                    {{
                                        member.resultingBalance
                                            | currency
                                            : "CAD"
                                                : "symbol-narrow"
                                                : "1.2-2"
                                    }}
                                </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</form>
<div *ngIf="loadingPastCredits || loadingRosterMembers || loadingConfig">
    <span class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle
                class="path"
                cx="50"
                cy="50"
                fill="none"
                r="20"
                stroke-miterlimit="10"
                stroke-width="2"
            />
        </svg>
    </span>
</div>
